import { types } from '../actions/types';

export const VersionReducer = (
  state = {
    data: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.bmGetVersions:
      return {
        ...state,
        data: action.payload,
      };
    case types.bmCreateVersion:
      return {
        ...state,
        create: action.payload,
      };
    case types.bmUpdateVersion:
      return {
        ...state,
        update: action.payload,
      };
    case types.bmDeleteVersionById:
      return {
        ...state,
        deleteById: action.payload,
      };
    default:
      return state;
  }
};
